const mergeObject = (target, source) => {
  const destination = {};
  if (isPureObject(target)) {
    Object.keys(target).forEach(key => {
      destination[key] = target[key];
    });
  }
  if (isPureObject(target)) {
    Object.keys(source).forEach(key => {
      if (!isPureObject(source[key]) || !target[key]) {
        destination[key] = source[key];
      } else {
        destination[key] = mergeObject(target[key], source[key]);
      }
    });
  } else {
    return source;
  }
  return destination;
};

export const objectsIsEqual = (objA, objB) => {
  if (objA === objB) return true;
  if (!isPureObject(objA) || !isPureObject(objB)) return false;
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (let keyA of keysA) {
    if (!bHasOwnProperty(keyA)) return false;
    if (!objectsIsEqual(objA[keyA], objB[keyA])) return false;
  }
  return true;
};

export const deepEqual = (...array) => {
  for (let i = 1; i < array.length; i++) {
    if (!objectsIsEqual(array[i - 1], array[i])) return false;
  }
  return true;
};

export const isPureObject = val => val && typeof val === 'object' && Object.prototype.toString.call(val) === '[object Object]';

export const deepMerge = (target, ...array) => array.reduce((prev, next) => mergeObject(prev, next), target);
